export const FT5_TRACKING_RELOAD = 'ft5.tracking.reload';

export const SHOEN_PRINCIPAL_ORG_PATH = 'o-oj8k4zmxa2/r-8bpq/ou-8bpq-u86o9kx2/**
 *
 *
 *
 */
export const RELOAD_COMPONENT_TOPIC = 'ft5.components.reload';
/**
 *
 */
export const DIMENSION_SELECTED_TOPIC = 'ft5.ui-aggregation.dimensionsSelected';

export const OTTO_RETAILER_ID = '1000000';

export const CONFIG_TOGGLE_BROKEN_DIMENSIONS = 'CONFIG_FILTER_BROKEN_DIMENSIONS';

export const CONFIG_SHOW_WATO_BANNER = 'CONFIG_SHOW_WATO_BANNER';

export const LAST_SELECTED_VARIATION_ID_COOKIE_NAME = 'ft5-pdp-last-selected-variation-id';

export const CR_LANDING_PAGE_REVIEW_LIST_PAGE_SIZE = 30;

export const OPEN_AMBIENT_IMAGE_GENERATION_TOPIC = 'ft5.ui-aggregation.openAmbientImageGeneration';

/**
 *
 *
 *
 */
export const USER_TEST_PARAM = 'tid';

/*                                                            */
export const USER_TEST_ID_PRODUCT_ROOM_FIT = '8f31c0a7';
